import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import Box from '@mui/material/Box';
import { Controller } from 'react-hook-form';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import { Typography } from '@mui/material';
import { REGISTRATION_FIELD_FILL_BG } from '../registrationFormFieldStyles';
import { ErrorWithIcon } from '@ui/components/common/TextField/ErrorWithIcon';
import InfoIconTooltip from '@ui/components/common/Tooltips/InfoIconTooltip';
const ERadioGroup = ({ name, control, label, options, rules, error, bgColor = REGISTRATION_FIELD_FILL_BG, tooltipText, disabled = false, ...rest }) => {
    const styledLabel = useMemo(() => !label ? undefined : (_jsxs(Box, { display: 'inline-flex', alignItems: 'center', gap: '4px', sx: { pointerEvents: 'auto' }, children: [_jsx(Typography, { variant: 'body2', color: disabled ? 'text.disabled' : 'text.primary', children: label }), tooltipText && (_jsx(Box, { sx: {
                    display: 'inline-flex',
                    alignItems: 'center',
                    pointerEvents: 'auto',
                    cursor: 'pointer'
                }, children: _jsx(InfoIconTooltip, { title: tooltipText, size: 'small', variant: 'dark' }) }))] })), [label, tooltipText]);
    return (_jsxs(Box, { width: '100%', children: [_jsxs(Box, { sx: {
                    background: bgColor,
                    borderRadius: '12px',
                    padding: '12px',
                    width: '100%'
                }, children: [styledLabel, _jsx(Controller, { name: name, control: control, rules: rules, render: ({ field }) => (_jsx(RadioGroup, { ...field, ...rest, value: String(field.value), onChange: (e, value) => {
                                if (disabled)
                                    return;
                                field.onChange(String(value));
                            }, children: options.map((opt) => (_jsx(FormControlLabel, { value: opt.value, disabled: disabled, control: _jsx(Radio, { size: 'small', disabled: disabled }), label: opt.label, sx: {
                                    marginLeft: 0,
                                    '.MuiTypography-root': {
                                        fontSize: '14px',
                                        fontWeight: 400
                                    }
                                } }, opt.value))) })) })] }), _jsx(ErrorWithIcon, { error: error, mt: 0.5, ml: 0.5 })] }));
};
export default ERadioGroup;
